const content: { [key: string]: any } = {
  title: "Ruby Bonus",
  description: "Earn 2% of your Ruby BV when you reach the monthly Ruby PV requirement.",
  rubyBV: "Ruby BV",
  rubyPV: "Ruby PV",
  rubyMultiplier: "Ruby Multiplier",
  rubyBonusTotal: "Ruby Bonus Total",
  notAvailable: "N/A",
};

export default content;
